import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import arrow from "../assets/images/head5.png";
import InputBox from "../components/InputBox";
import { toast } from "react-toastify";
import { sendContact } from "../utils/apis";
import Button from "../components/Button";
import { email_reg } from "../utils/utils";

const Contact = () => {
  const isBigScreen = useMediaQuery({ query: "(min-width: 992px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const send_contact = () => {
    if (
      !data.mobile ||
      !data.mess ||
      !data.name ||
      !data.subject ||
      !data.email
    ) {
      setData({
        ...data,
        namemess: "name is required",
        emailmess: "email is required",
        subjectmess: "subject is required",
        messmess: "message is required",
        mobilemess: "mobile is required",
      });
      return;
    }
    const body = new FormData();
    body.append("mobile", data.mobile);
    body.append("message", data.mess);
    body.append("name", data.name);
    body.append("subject", data.subject);
    body.append("email", data.email);
    sendContact(body, setLoading).then((res) => {
      if (res.success) {
        setData({
          ...data,
          name: "",
          mess: "",
          subject: "",
          email: "",
          mobile: "",
        });
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    });
  };
  return (
    <>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.890992665943!2d78.5488404!3d17.4010947!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb993c125b9439%3A0x44fcaa4e823dc192!2sBig%20Drum%20India%20Private%20Limited!5e0!3m2!1sen!2sin!4v1687179958189!5m2!1sen!2sin"
        width={"100%"}
        style={{ border: 0 }}
        height={isBigScreen ? "400" : isMobile ? "200" : "300"}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
      <div className="div-wrapper">
        <div className="div-wrapper-inner flex">
          <img src={arrow} className="arrow_img mt ml" />
          <div className="df-contact gap20 w100">
            <div className="flex">
              <InputBox
                title={"Name"}
                placeholder={"Your Name"}
                value={data.name}
                onChange={(e) =>
                  setData({ ...data, name: e.target.value, namemess: "" })
                }
                mess={data.namemess}
              />
              <div className="df gap20">
                <InputBox
                  title={"Email"}
                  placeholder={"Email Address"}
                  value={data.email}
                  onChange={(e) =>
                    setData({ ...data, email: e.target.value, emailmess: "" })
                  }
                  mess={data.emailmess}
                />
                <InputBox
                  title={"Phone"}
                  placeholder={"Phone Number"}
                  value={data.mobile}
                  onChange={(e) =>
                    setData({
                      ...data,
                      mobile: e.target.value.replace(/\D/g, ""),
                      mobilemess: "",
                    })
                  }
                  mess={data.mobilemess}
                />
              </div>
              <InputBox
                title={"Subject"}
                placeholder={"Subject"}
                value={data.subject}
                onChange={(e) =>
                  setData({ ...data, subject: e.target.value, subjectmess: "" })
                }
                mess={data.subjectmess}
              />
              <InputBox
                title={"Message"}
                placeholder={"Message"}
                area
                value={data.mess}
                onChange={(e) =>
                  setData({ ...data, mess: e.target.value, messmess: "" })
                }
                mess={data.messmess}
              />
              <div className="button-div mb mt">
                <Button
                  title={"Send message"}
                  loading={loading}
                  onClick={send_contact}
                />
              </div>
            </div>

            <div className="flex mb">
              <h3>Registered And Corporate Office</h3>
              <p className="mb">
                Big Drum India Pvt. Ltd. Plot #10, I.D.A.Uppal, Hyderabad,
                Telangana - 560039. India.
              </p>
              <h3>Email</h3>
              <p className="mb">info@bigdrumindia.com</p>
              <h3>Phone</h3>
              <p>+91 9347933535 / +91 9000488466</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
